import { render, staticRenderFns } from "./DialogLabel.vue?vue&type=template&id=6ef89d59"
import script from "./DialogLabel.vue?vue&type=script&lang=js"
export * from "./DialogLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports